// @flow

import React from "react";

import { WISTIA_VIDEOS } from "./video-codes";

type Props = $Exact<{
  videoId: string,
  title?: string,
}>;

const WistiaPlayer = ({ videoId, title }: Props) =>
  videoId ? (
    <div className="responsive-wistia-player">
      <iframe
        width="850"
        height="480"
        src={`https://fast.wistia.net/embed/iframe/${videoId}?seo=false&resumable=false`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title || "Wistia Video"}
      />
      <script src="https://fast.wistia.net/assets/external/E-v1.js" async />
    </div>
  ) : null;

WistiaPlayer.videos = WISTIA_VIDEOS;

export default WistiaPlayer;
